import React from "react";
import { Answer } from "../../endpoints/results.type";

interface QuestionAnswerButtonProps {
  label: string;
  answer: Answer;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  selected: boolean;
  color?: string;
}

const QuestionAnswerButton: React.FC<QuestionAnswerButtonProps> = ({
  label,
  answer,
  onClick,
  disabled = false,
  selected = false,
  className = "text-md font-bold",
  color = "bg-blue-500",
}) => {
  const isImage = answer.image_url !== null;

  const imageAnswer = (
    <div>
      <span className="text-sm font-bold">
        {label}
      </span>
      {answer.image_url && (
        <img
          src={answer.image_url}
          alt={label}
          className="w-28 h-28 rounded-lg object-cover"
        />
      )}
    </div>
  );

  const average = (answer.intervals.map(interval => interval.raw_percent * 100).reduce((a, b) => a + b, 0) / answer.intervals.length).toFixed(0);
  const weightedAverage = (answer.intervals.map(interval => interval.raw_percent * 100 * interval.unique_users).reduce((a, b) => a + b, 0) / answer.intervals.map(interval => interval.unique_users).reduce((a, b) => a + b, 0)).toFixed(0);
  const totalUsers = answer.intervals.map(interval => interval.unique_users).reduce((a, b) => a + b, 0);

  const textAnswer = (
    <div className="flex flex-col items-center relative">
      <span className="text-md font-bold">
        {label}
      </span>
      <div className="flex flex-row items-center justify-between w-full">
        <div className="text-md font-normal">
          {weightedAverage}
          %
        </div>
        <div className="w-5" />
        <div className="text-md font-normal">
          {totalUsers}
        </div>
      </div>
      <div className="flex flex-row items-center justify-between w-full -mt-2">
        <div className="text-xs font-light">
          average
        </div>
        <div className="w-5" />
        <div className="text-xs font-light">
          answers
        </div>
      </div>
    </div>
  );

  return (
    <button
      type="button"
      className={`${selected ? color + ' text-white' : 'bg-white text-black'} hover:opacity-65 disabled:opacity-50 ${className} ${isImage ? 'p-2' : 'p-3'}`}
      onClick={onClick}
      disabled={disabled}
    >
      {isImage ? imageAnswer : textAnswer}
    </button>
  );
};

export default QuestionAnswerButton;
